"use client";

import React from "react";
import { ResponsiveModal, ModalContainer, MODAL_IDS } from "@west-tennessee-consulting/ui";
import { ContactConsolidationForm } from "./ContactConsolidationModal";
import type { ConsolidateContactModalData } from "@/lib/modals/data/modal-data-types";

/**
 * Contact Consolidation Modal Wrapper - Global Modal Stack pattern
 *
 * This component:
 * 1. Registers with the global modal stack using ModalContainer
 * 2. Reads contactId from modal context via ModalContainer
 * 3. Renders the ContactConsolidationForm with the contactId
 * 4. Lets ModalContainer handle all modal state and closing
 *
 * Usage from SimpleTable row action:
 * ```typescript
 * openModal(MODAL_IDS.contacts.consolidate, {
 *   contactId: item.id,
 *   prefillData: { ... }
 * });
 * ```
 */
export function ContactConsolidationModalWrapper() {
  return (
    <ModalContainer<ConsolidateContactModalData> modalId={MODAL_IDS.contacts.consolidate}>
      {({ isOpen, data, onClose }) => {
        const contactId = data?.contactId;

        return (
          <ResponsiveModal
            globalModalId={MODAL_IDS.contacts.consolidate}
            title="Consolidate Contact"
            description="Merge this contact with another contact. All data will be combined and the source contact will be deleted."
            maxWidth="lg"
          >
            <ContactConsolidationForm
              contactId={contactId}
              onClose={onClose}
            />
          </ResponsiveModal>
        );
      }}
    </ModalContainer>
  );
}
